/* eslint-disable import/prefer-default-export */
export const BANNER_EXPIRATION_IN_MILLISECONDS = 86400 * 28 * 1000; // 28 days
export const RATINGS_MODAL_MAX_SHOW = 3;
export const MIN_AGE = 18;
export const MAX_AGE = 116;
export const DEFAULT_AGE = 30;
export const CP_LIVE_URL_REGEX = /^(\/pricing)?\/live($|\/)/;
export const CP_LIVE_PARTNER_ALIAS = 'classpass-live';
export const CHROMECAST_NAMESPACE = 'urn:x-cast:classpass.video';
export const HR_SKU = 'CPLWH-TICKR01';
export const VIDEO_CLASS_STATE = {
  SCHEDULED: 'SCHEDULED',
  STARTED: 'STARTED',
  STOPPED: 'STOPPED',
  ENDED: 'ENDED',
  VOD: 'VOD',
};
export const ZONE_COLORS = ['#0065ff', '#65c61c', '#fad525', '#f3753c', '#ec1a38'];
export const ZONES = [
  {
    label: 'Rest',
    max: 60,
    min: 30,
  },
  {
    label: 'Endurance',
    max: 70,
    min: 60,
  },
  {
    label: 'Cardio',
    max: 80,
    min: 70,
  },
  {
    label: 'Burn',
    max: 90,
    min: 80,
  },
  {
    label: 'Max',
    max: 100,
    min: 90,
  },
];
